// Picker bottom sheets on the web (token / account pickers on Operations and the deposit screens). In the app
// they stretch to the top of the screen and are closed by a swipe down — which a mouse can't do and a finger
// rarely tries in a browser, and with no free space left there is nothing to tap to get out. On the web the
// sheet takes the lower half and sits on a dimmed backdrop; a tap on the backdrop closes it.
//
// Every picker is the same height, whatever the number of rows. The backdrop shows at once and only the sheet
// slides up: a Modal with animationType "slide" moves its whole content, backdrop included, so on the web the
// pickers' Modals take WEB_SHEET_MODAL_ANIMATION ("none") and the sheet animates itself.
import { Platform, StyleSheet } from 'react-native';
import { COLORS } from '../src/theme/themeTokens';

const web = Platform.OS === 'web';

const styles = StyleSheet.create({
  sheet: {
    flex: -1,
    marginTop: 0,
    // The same 55 % for every picker, but never shorter than its rows: in Safari, with its toolbar, 55 % of the
    // window is less than a handful of rows, and a sheet that scrolled moved its rows and handle inside itself
    // under a swipe down. Only a list past 85 % scrolls.
    minHeight: '55%',
    maxHeight: '85%',
    overflow: 'auto',
    overscrollBehavior: 'none',
    animationDuration: '250ms',
    animationTimingFunction: 'cubic-bezier(0.215, 0.61, 0.355, 1)',
    animationKeyframes: { '0%': { transform: 'translateY(100%)' }, '100%': { transform: 'translateY(0%)' } },
  } as object,
});

/** Modal `animationType` for a picker sheet: the web shows the backdrop at once, the sheet slides by itself. */
export const WEB_SHEET_MODAL_ANIMATION = web ? ('none' as const) : undefined;

/** On the sheet itself, after its own style: at least the lower 55 % of the screen, slides up when shown. */
export const WEB_SHEET = web ? styles.sheet : null;

/** On a list inside the sheet that has `flex: 1`: let it take its rows' height and scroll past the limit. */
export const WEB_SHEET_LIST = web ? ({ flex: -1, overscrollBehavior: 'none' } as const) : null;

/** On the full-screen layer under the sheet that closes it on a tap. */
export const WEB_SHEET_BACKDROP = web ? ({ backgroundColor: COLORS.overlay } as const) : null;
